import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { sentry } from 'legacy/utils/sentry'

import { assignDriverToShipment } from '../../use-cases/assignDriverToShipment'

export function useAssignDriver() {
  const [requestStatus, setRequestStatus] = useState(RequestStatus.Initial)

  const patchAssignDriver = useCallback(async (driverUUID: string, shipmentUUID: string) => {
    setRequestStatus(RequestStatus.Pending)
    try {
      await assignDriverToShipment({ driverUUID, shipmentUUID })
      setRequestStatus(RequestStatus.Done)
    } catch (error) {
      sentry.log(error)
      setRequestStatus(RequestStatus.Error)
    }
  }, [])

  return { patchAssignDriver, requestStatus }
}
